import { render } from "./TitleYellow.vue?vue&type=template&id=34414b8c&scoped=true"
import script from "./TitleYellow.vue?vue&type=script&lang=js"
export * from "./TitleYellow.vue?vue&type=script&lang=js"

import "./TitleYellow.vue?vue&type=style&index=0&id=34414b8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34414b8c"]])

export default __exports__